import React from "react";
import {Grid} from "@mui/material";
import {KeySnapshotUpdate} from "../../api/KeyHistoryLastUpdatesStore";
import {Location, locationTypeOptions, toLocationTypeEnum} from "../../components/location/KeyLocationShield";
import {filterSerializer} from "../../util/FilterSerializer";
import {SetState} from "../../util/FormHandlers";
import {TextSearchFilter} from "../../components/filter-fields/TextSearchFilter";
import {ClearFilterButton} from "../../components/filter-fields/ClearFilterButton";
import {KeyVaultFilterOpt} from "../../components/filter-fields/KeyVaultFilter";
import {KeyVault} from "../../api/Model";
import {andFilter, applyFilter, filterText, filterValue, matchMultiSelect} from "../../util/FilterUtil";
import {LocationFilter} from "../../components/filter-fields/LocationFilter";

export interface KeyLastUpdatesFilterForm {
    keyVault: KeyVault | null;
    location: Location[];
    search: string;
}

export const emptyKeyLastUpdatesFilter: KeyLastUpdatesFilterForm = {
    keyVault: null,
    location: [],
    search: "",
};

export const keyLastUpdatesFilterSerializer = (keyVaults: KeyVault[]) => filterSerializer<KeyLastUpdatesFilterForm>(
    emptyKeyLastUpdatesFilter,
    b => {
        b.keyVault("keyVault", keyVaults);
        b.strArray("location");
        b.str("search");
    },
);

export function filterKeyLastUpdatesRows(rows: KeySnapshotUpdate[], filter: KeyLastUpdatesFilterForm): KeySnapshotUpdate[] {
    const keyVaultId = filter.keyVault?.id;
    return applyFilter(rows, andFilter(
        filterValue(
            keyVaultId !== undefined ? (vaultId: KeyVault['id']) => vaultId === keyVaultId : null,
            row => row.historyRecord.vault.id,
        ),
        filterValue(
            matchMultiSelect(filter.location),
            row => row.historyRecord.location.type,
        ),
        filterText(filter.search, row => {
            const {
                locationType,
                employee,
                guestFullName,
                guestCompany
            } = toLocationTypeEnum(row.historyRecord.location);

            return [
                row.key.keyNumber,
                row.key.transponderId,
                ...row.key.tags.map(tag => tag.name),
                row.historyRecord.vault.name,
                locationTypeOptions[locationType].label,
                employee?.fullName,
                guestFullName,
                guestCompany,
                row.historyRecord.from,
                row.historyRecord.to,
                row.historyRecord.notes,
                row.historyRecord.updatedBy,
                row.historyRecord.createdBy,
            ];
        }),
    ));
}

export function KeyLastUpdatesFilter({filter, setFilter}: {
    filter: KeyLastUpdatesFilterForm;
    setFilter: SetState<KeyLastUpdatesFilterForm>;
}) {
    return (
        <Grid container spacing={2} alignItems="center">
            <KeyVaultFilterOpt filter={filter} setFilter={setFilter}/>
            <LocationFilter filter={filter} setFilter={setFilter}/>
            <TextSearchFilter filter={filter} setFilter={setFilter} property="search"/>
            <ClearFilterButton emptyFilter={emptyKeyLastUpdatesFilter} setFilter={setFilter}/>
        </Grid>
    );
}
